import classNames from "classnames";
import React, { FC } from "react";

import { Swiper } from "../../components/swiper/Swiper";

/**
 * "Billable" on/off for a time entry. Non-billable time is never offered for
 * an invoice and doesn't count as unbilled.
 */
export const BillableSwitch: FC<{
  value: boolean;
  onChange: (value: boolean) => void;
  className?: string;
  /** Time already on an invoice can't be switched. */
  disabledReason?: string;
}> = ({ value, onChange, className, disabledReason }) => (
  <div
    className={classNames(
      "flex items-center justify-between gap-4 rounded-lg border border-[#DCE2EA] px-3 py-2.5",
      className,
    )}>
    <div>
      <div className={"text-sm font-semibold text-[#1D2C3B]"}>Billable</div>
      <div className={"text-xs text-[#6B7280]"}>
        {disabledReason ||
          (value
            ? "This time can be added to an invoice."
            : "Not charged to the client (won't show on invoices).")}
      </div>
    </div>
    <div
      className={classNames(disabledReason && "pointer-events-none opacity-50")}
      aria-disabled={!!disabledReason}>
      <Swiper
        value={value}
        onChange={onChange}
        description={value ? "Billable" : "Non-billable"}
        descriptionPosition={"left"}
        size={"sm"}
      />
    </div>
  </div>
);
